import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DecisionScoreCardContainer = styled(Stack)<{
  isSelected: boolean;
  theme: any;
  isLoading?: boolean;
}>(({ theme, isSelected, isLoading }) => ({
  backgroundColor: theme.palette.dsSurface.v100,
  flex: "0 0 auto",
  borderRadius: theme.spacing(2),
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1, 3),
  cursor: "pointer",
  border: isSelected ? `1px solid ${theme.palette.dsPrimary.v300}` : `1px solid ${theme.palette.dsSurface.v300}`,
  transition: "border-color 0.2s ease-in-out, background 0.2s ease-in-out",
  minHeight: theme.spacing(7),
  maxWidth: theme.spacing(45),
  "&:hover": {
    background: isSelected
      ? `linear-gradient(${theme.palette.dsPrimary.v300}10, ${theme.palette.dsPrimary.v300}10), ${theme.palette.dsSurface.v100}`
      : theme.palette.dsSurface.v300,
  },
  background: isSelected
    ? `linear-gradient(${theme.palette.dsPrimary.v300}10, ${theme.palette.dsPrimary.v300}10), ${theme.palette.dsSurface.v100}`
    : theme.palette.dsSurface.v100,
  width: theme.spacing(45),
  minWidth: theme.spacing(45),
  flexShrink: 0,
}));

export const DecisionCardsRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(2),
  flex: 1,
  alignItems: "stretch",
}));

export const NavigationButton = styled(Box)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  cursor: disabled ? "default" : "pointer",
  opacity: disabled ? 0.3 : 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  minWidth: 40,
  maxWidth: 40,
  height: 40,
  minHeight: 40,
  maxHeight: 40,
  flexShrink: 0,
  borderRadius: 10,
  background: theme.palette.dsSurface.v300,
  border: `1px solid ${theme.palette.dsSurface.v500}`,
  transition: "all 0.2s ease",
  "&:hover": disabled
    ? {}
    : {
        backgroundColor: theme.palette.dsSurface.v200,
      },
}));

export const NoDataContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.dsSurface.v100,
  flex: 1,
  borderRadius: theme.spacing(2),
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3),
}));
